// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3lyxi","description":"PatientConsentPreview_description__3HKhe"};